import { Divider, Modal } from "antd"
import { ItemData } from "../ItemData"
import { ContractDetail, ServiceContract } from "src/common/models/contract"
import { CharacteristicsForm } from "src/features/Service/ServiceForm/CharacteristicsForm"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/state/reducer"
import { updateCurrentContract } from "src/features/ServiceContract/state/action"
import { SystemDescriptions } from "src/common/descriptions"

export type ReduxProps = {
    currentContract?: Partial<ServiceContract>
}

interface Props {
    open: boolean
    onCancel: VoidFunction
    onAccept: VoidFunction
    okText: string
    cancelText: string
    itemDetail: ContractDetail
}

export const CharacteristicsModal = (props: Props) => {
    const dispatch = useDispatch()

    const [cleanFlag, setCleanFlag] = useState<boolean>(false)

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        currentContract: state.serviceContract.currentContract,
    }))

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.CREATE_SERVICE_CONTRACT

    useEffect(() => {
        if (props.open) {
            setCleanFlag(false)
        }
    }, [props.open])


    return (
        <Modal
            title={descriptions.CHARACTERISTICS.TITLE}
            centered
            open={props.open}
            width={600}
            onOk={props.onAccept}
            okText={props.okText}
            cancelText={props.cancelText}
            footer={<></>}
            closable={false}
            zIndex={1200}
            getContainer={false}
            destroyOnClose={true}
        >
            <ItemData itemDetail={props.itemDetail} />
            <Divider />
            <CharacteristicsForm
                onCancel={props.onCancel}
                onAccept={(characteristics: string[]) => {
                    const newDetail = reduxProps.currentContract?.detail?.map(item => {
                        if (item.ref === props.itemDetail.ref) {
                            item.characteristics = characteristics
                        }
                        return item
                    })

                    dispatch(updateCurrentContract({
                        detail: newDetail,
                    }))

                    props.onAccept()
                }}
                initialValues={props.itemDetail.characteristics}
                clean={cleanFlag}
            />
        </Modal>
    )
}
